import { actionTypes as firestoretypes } from 'redux-firestore';
import * as sagaEffects from 'redux-saga/effects';
import { get as _get } from 'lodash';

import { setInProcess } from '../actions';
import { selectImportInProcessFlag } from '../selectors';

const { takeEvery, put, select } = sagaEffects;

function* handler({ meta, payload }) {
    const hasImportInProcess = yield select(selectImportInProcessFlag);
    if (meta.storeAs === 'lastImport') {
        const lastImport = _get(payload, 'ordered.0', null);
        const importInProcess = Boolean(lastImport && lastImport.importInProgress);

        if (hasImportInProcess !== importInProcess) {
            yield put(setInProcess(importInProcess));
        }
    }
}

export default function* () {
    yield takeEvery(firestoretypes.LISTENER_RESPONSE, handler);
}
